import { css } from '@emotion/core';
import styled from '@emotion/styled';

export const GridContainer = styled.div<{ marginBottom?: number | string | null }>`
  display: grid;
  grid-template-columns: 45% 1fr;
  align-items: flex-start;
  ${({ marginBottom = 0 }) => css`
    margin-bottom: ${marginBottom}px;
  `}
`;

export const HeaderToggles = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  text-align: center;
`;
